import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory, useParams } from "react-router";
import {
  showLoadingPage,
  hiddenLoadingPage,
} from "../../../actions/loadingPage";
import { useDispatch, useSelector } from "react-redux";
import { userCoinBalance } from "../../../actions/user";
import { LoadingPage } from "../../LoadingPage/LoadingPage";
import { showBetterCoinBalance } from "../../../utils/showBetterPrice";
//Components
import ExternalTransfer from "./ExternalTransfer";
import InternalTransfer from "./InternalTransfer";
import ErrorBox from "../../../helpers/errors_notifications/ErrorBox";
//ICONS
import styles from "./TransferCoin.module.scss";
import RectAngel from "../../../styles/icon/rectangel2.svg";
import TimerIcon from "../../../styles/icon/timer.svg";
import PolygonBlue from "../../../styles/icon/polygon_blue.svg";
import PolygonGreen from "../../../styles/icon/polygon_green.svg";
import ArrowBackIcon from "../../../styles/icon/arrow_back_fill.svg";

export default function TransferCoin() {
  const history = useHistory();
  //GET DATA FROM STORE
  const [deactivatedBtn, setDeactivatedBtn] = useState(false);
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const [error, setError] = useState("");
  const CoinBalance = useSelector((state) => state.fullUserInfo?.coinBalance);
  //END GET DATA
  const dispatch = useDispatch();
  const { search } = useLocation();
  const { name } = useParams();
  useEffect(() => {
    let mounted = true;
    const isInternal = search.includes("wth=internal");
    if (isInternal) setSwitchTransfer("internal");
    if (mounted) {
      (async () => {
        dispatch(showLoadingPage());
        await getUpdatedInfo();
        dispatch(hiddenLoadingPage());
      })();
    }
    return () => (mounted = false);
  }, [search, name]);

  useEffect(() => {
    if (CoinBalance && !CoinBalance?.gaCode)
      setError("برای برداشت ارز نیاز به فعال سازی شناسایی دوعاملی میباشد");
  }, [CoinBalance]);
  ////
  ////
  //UPDATE PAGE FUNCTION
  const getUpdatedInfo = async () => {
    setDeactivatedBtn(true);
    await dispatch(userCoinBalance(name));
    const timer = setTimeout(() => {
      setDeactivatedBtn(false);
    }, 3000);
    return () => clearTimeout(timer);
  };
  //END UPDATE PAGE FUNCTION
  //
  //JUST SWITCH BUTTON
  const [switchTransfer, setSwitchTransfer] = useState("external");
  //END SWITCH BUTTON
  //

  return (
    <>
      {loadingBar && <LoadingPage />}
      <ErrorBox text={error} setText={setError} />
      <div className={styles.container}>
        <div className={styles.backIcon}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.goBack()}
            className="convertPicToWhite"
          />
        </div>
        <div className={styles.container_responsive}>
          <div className={styles.header_of_transfer}>
            <div className={styles.coin_picture}>
              <img
                src={`/images/assets-logo/${CoinBalance?.asset?.symbol}.png`}
                alt={CoinBalance?.asset?.symbol}
                width={65}
                height={65}
              />
            </div>
            <div className={styles.title_of_page}>
              <img src={RectAngel} alt="" />
              <p>برداشت</p>
            </div>
            <div className={`font_color_white ${styles.coin_name}`}>
              {CoinBalance?.asset?.name} ({CoinBalance?.asset?.symbol})
            </div>
            <button
              className={styles.refresh_button}
              onClick={() => getUpdatedInfo()}
              disabled={deactivatedBtn}
            >
              <div className={styles.refresh_icon}>
                <img src={TimerIcon} alt="" width={14} height={14} />
              </div>
              <div className={styles.refresh_text}>بروزرسانی</div>
            </button>
            <div className={styles.line_header_withdraw}></div>
          </div>

          <div className={styles.main_withdraw}>
            <div
              className={`changeBackgroundToGreen font_color_white ${styles.coin_persian_name}`}
            >
              {CoinBalance?.asset?.faName}
            </div>
            <div className={`font_color_white ${styles.title_of_total_coin}`}>
              <img src={PolygonGreen} alt="" width={8} height={8} />
              <div>: موجودی کل</div>
            </div>
            <div className={`font_color_white ${styles.total_coin}`}>
              <span>{CoinBalance?.asset?.symbol}</span>
              <span>{showBetterCoinBalance(CoinBalance?.asset?.balance)}</span>
            </div>
            <div className={`font_color_white ${styles.title_of_coin_locked}`}>
              <img src={PolygonBlue} alt="" width={8} height={8} />
              <div>: قفل شده</div>
            </div>
            <div className={`font_color_white ${styles.total_coin_locked}`}>
              <span>{CoinBalance?.asset?.symbol}</span>
              <span>{showBetterCoinBalance(CoinBalance?.asset?.locked)}</span>
            </div>
            <div className={`font_color_white ${styles.title_removable_coin}`}>
              <img src={PolygonBlue} alt="" width={8} height={8} />
              <div>: قابل برداشت</div>
            </div>
            <div className={`font_color_white ${styles.total_removable_coin}`}>
              <span>{CoinBalance?.asset?.symbol}</span>
              <span>
                {CoinBalance?.asset?.balance &&
                  CoinBalance?.asset?.balance - CoinBalance?.asset?.locked}
              </span>
            </div>
          </div>

          <div className={styles.switch_withdraw_buttons}>
            <div
              className={`font_color_white  ${
                styles.transfer_external_switch
              } ${
                switchTransfer === "external"
                  ? `${styles.active_transfer_button} changeBackgroundColorToGreen`
                  : ""
              }`}
              onClick={() => setSwitchTransfer("external")}
            >
              به کیف پول
            </div>
            <div
              className={` font_color_white   ${
                styles.transfer_internal_switch
              } ${
                switchTransfer === "internal"
                  ? `${styles.active_transfer_button} changeBackgroundColorToGreen`
                  : ""
              }`}
              onClick={() => setSwitchTransfer("internal")}
            >
              انتقال داخلی
            </div>
          </div>

          <section>
            {switchTransfer === "external" ? (
              <ExternalTransfer balances={CoinBalance} name={name} />
            ) : switchTransfer === "internal" ? (
              <InternalTransfer balances={CoinBalance} name={name} />
            ) : (
              "RELOAD THE APP OR CONTACT SUPPORT"
            )}
          </section>
        </div>
      </div>
    </>
  );
}
